export default __webpack_public_path__ + "static/media/ic_live.d0be5c4f.svg";